import { useServiceStore } from "@opendash/core";
import { WidgetInterface, useMonitoringService } from "..";

export function useWidgets(): WidgetInterface<any>[] {
  const monitoring = useMonitoringService();

  return useServiceStore(monitoring, (state) => state.allWidgets);
}
